// Third-parties.
import { useEffect, useContext } from 'react';

// Contexts.
import { TimeRangeContext } from '../../context/TimeRangeContext';

function InstanaDatabaseButton(props: { instanaServiceUrl: string }) {
    const { timeRange } = useContext(TimeRangeContext);
        
	useEffect (() =>
	{
		
	}, []);

    return (
        <button type="button" className="btn btn-xsm btn-outline-secondary float-end" data-tooltip-id="global-tooltip" data-tooltip-content="View this database in Instana" onClick={() => window.open(`${props.instanaServiceUrl}?timeline.to=${timeRange.to.valueOf()}&timeline.fm=${timeRange.from.valueOf()}&timeline.ws=${timeRange.to.diff(timeRange.from, 'millisecond')}`, "_blank")}><i className="fak fa-stan fa-fw" aria-hidden="true"></i>Instana</button>
    );
}

export default InstanaDatabaseButton;
